<template class="mt-2">
    <FormSection title="CAHPS Survey Recipient" :full-height="false" :application-id="application">
        <template #content>
            <div class="d-flex flex-column px-3 py-2">
                <div class="form-group">
                    <label for="emergency-preparedness-information"> Emergency Preparedness Information </label>
                    <template v-for="[, information] in cahpsSurveyRecipients" :key="information.value">
                        <div class="d-none" v-if="information.value === cahpsSurveyRecipientEnum.None"></div>
                        <template v-else>
                            <div class="form-check flex-col py-1 px-0">
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input
                                        type="radio"
                                        class="custom-control-input au-target"
                                        name="recipientType"
                                        :id="`source_${information.name}`"
                                        :value="information.value"
                                        :checked="patientDetails.recipientType === information.value"
                                        @click="onSelectCahpsSurveyRecipientOption(information.value)"
                                    />
                                    <label class="custom-control-label" :for="`source_${information.name}`">
                                        <span class="me-1">{{ information.name }}</span>
                                    </label>
                                    <a
                                        tabindex="0"
                                        href="javascript:void(0);"
                                        role="button"
                                        v-if="information.longDescription"
                                        v-custom-popover="{ content: information.longDescription }"
                                    >
                                        <i class="fas fa-info-circle text-primary font-size-xs"></i>
                                    </a>
                                </div>
                            </div>
                            <div
                                class="ms-4"
                                v-if="
                                    patientDetails.recipientType === information.value &&
                                    information.value !== cahpsSurveyRecipientEnum.NoEligibleCaregiver
                                "
                            >
                                <div class="form-group col-12 col-lg-5 mt-2">
                                    <select
                                        id="recipient_Id"
                                        name="recipientId"
                                        class="form-control au-target"
                                        v-model="patientDetails.recipientId"
                                    >
                                        <option class="au-target" selected :value="null">
                                            Select Authorized Contact
                                        </option>
                                        <option
                                            class="au-target"
                                            v-for="contact of contacts"
                                            :key="contact.id"
                                            :value="contact?.id"
                                        >
                                            {{ contact?.firstName }} {{ contact.lastName }}
                                        </option>
                                    </select>
                                </div>
                                <div
                                    class="form-group col-12 col-lg-7 mt-4"
                                    v-if="
                                        patientDetails.recipientType === information.value &&
                                        information.value === cahpsSurveyRecipientEnum.Unsolicited
                                    "
                                >
                                    <textarea
                                        class="form-control au-target"
                                        name="unsolicitedReason"
                                        v-model="patientDetails.unsolicitedReason"
                                        placeholder="Enter Reason"
                                        maxlength="80"
                                        cols="15"
                                        rows="5"
                                    ></textarea>
                                </div>
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script src="./CahpsSurveyRecipient.ts"></script>
